import {connect} from 'react-redux';
import {Cuvette as Component} from './Cuvette';
import {
  createCuvette,
  setCuvetteHeld,
  setHeldObject,
  setCuvetteControlVisibility,
  hideAllControls,
  setHeld,
  pushInteractions,
  spectrophotometerItemDrop,
  setCuvettesInScene
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("cuvettes") &&
     state.notebook.protocolSection.scene.apparatus.cuvettes.some(
       cuvette => cuvette.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].type,
      lidId: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].lidId,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id - 1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      inScene: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].inScene,
      solution: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].solution,
      tooltipLabel: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].tooltipLabel,

      interactionProps: {
        spectrophotometers: state.notebook.protocolSection.scene.apparatus.spectrophotometers,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createCuvette: (data)=>{
      dispatch(createCuvette(data))
    },
    setCuvetteHeld: (data) => {
      dispatch(setCuvetteHeld(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setCuvetteControlVisibility: (data) => {
      dispatch(setCuvetteControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    onDropCuvette: (data)=>{
      dispatch(spectrophotometerItemDrop(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setCuvettesInScene: (data) => {
      dispatch(setCuvettesInScene(data))
    },
  };
}

export const Cuvette = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
